// Global error
export const THROW_GLOBAL_ERROR = 'THROW_GLOBAL_ERROR';
export const SET_THEME_LIGHT = 'SET_THEME_LIGHT';
export const SET_THEME_DARK = 'SET_THEME_DARK';
export const SET_THEME_DARK_COMPACT = 'SET_THEME_DARK_COMPACT';
export const SET_THEME_LIGHT_COMPACT = 'SET_THEME_LIGHT_COMPACT';

// User
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_USER_DATA_INFO = 'SET_USER_DATA_INFO';
export const SET_USER_FETCH_STATUS = 'SET_USER_FETCH_STATUS';
export const CHECK_LS_JWT = 'CHECK_LS_JWT';

// singalR
export const SET_CONNECTION = 'SET_CONNECTION';
export const SET_COUNT_OF_UNREAD_MESSAGES = 'SET_COUNT_OF_UNREAD_MESSAGES';
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';

// raporty
export const INIT_SET_RAPORTY = 'INIT_SET_RAPORTY';
export const SET_RAPORT_DATA = 'SET_RAPORT_DATA';
export const REMOVE_RAPORT = 'REMOVE_RAPORT';
export const CLEAR_RAPORT_DATA = 'CLEAR_RAPORT_DATA';
export const REFRESH_RAPORT_DATA = 'REFRESH_RAPORT_DATA';
export const CLEAR_RAPORT_REFRESH = 'CLEAR_RAPORT_REFRESH';
